<header class="top-bar">
  <a class="product-lockup" routerLink="/" aria-label="Jonas AI Telemetry Hub">
    <span class="product-mark" aria-hidden="true">J</span>
    <span class="product-name">
      <strong>Jonas</strong>
      <span>AI Telemetry Hub</span>
    </span>
  </a>
  @if (layout.band() === 'sm') {
    <button
      type="button"
      class="menu-toggle"
      aria-label="Open navigation"
      [attr.aria-expanded]="layout.drawerOpen()"
      (click)="layout.openDrawer()"
      data-testid="nav-menu-toggle"
    >
      <fa-icon [icon]="menuIcon" aria-hidden="true" />
    </button>
  }
  <div class="search-placeholder">
    <fa-icon [icon]="searchIcon" aria-hidden="true" />
    <input
      type="search"
      disabled
      placeholder="Search is not available yet"
      aria-label="Search (not available yet)"
    />
  </div>
  <app-breadcrumb class="header-context" />
  @if (showProfile()) {
    <app-profile-menu />
  }
</header>
